import { render, staticRenderFns } from "./ComplaintCaseButton.vue?vue&type=template&id=4b98554e&scoped=true&"
import script from "./ComplaintCaseButton.vue?vue&type=script&lang=js&"
export * from "./ComplaintCaseButton.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintCaseButton.vue?vue&type=style&index=0&id=4b98554e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98554e",
  null
  
)

export default component.exports